import { IBorderClassGroup, BorderClassGroup } from "./borderClassGroups";
import { IColorClassGroup, ColorClassGroup } from "./colorClassGroups";
import { IDimensionsClassGroup, DimensionsClassGroup } from "./dimensionsClassGroup";
import { DisplayClassGroup, IDisplayClassGroup } from "./displayClassGroups";
import { FlexClassGroup, IFlexClassGroup } from "./flexClassGroups";
import { IPaddingClassGroup, PaddingClassGroup } from "./paddingClassGroups";
import { IPositionClassGroup, PositionClassGroup } from "./positionClassGroup";
import { IShadowClassGroup, ShadowClassGroup } from "./shadowClassGroups";
import { ITypographyClassGroup, TypographyClassGroup } from "./typographyClassGroups";

export * from "./typographyClassGroups";
export * from "./displayClassGroups";
export * from "./flexClassGroups";
export * from "./paddingClassGroups";
export * from "./borderClassGroups";
export * from "./colorClassGroups";
export * from "./shadowClassGroups";

export type IBasicClassGroup = IDimensionsClassGroup &
  ITypographyClassGroup &
  IDisplayClassGroup &
  IPositionClassGroup &
  IFlexClassGroup &
  IPaddingClassGroup &
  IBorderClassGroup &
  IShadowClassGroup &
  IColorClassGroup;
export type BasicClassNames = keyof IBasicClassGroup;
export const BasicClassGroup = {
  ...DimensionsClassGroup,
  ...TypographyClassGroup,
  ...DisplayClassGroup,
  ...PositionClassGroup,
  ...FlexClassGroup,
  ...PaddingClassGroup,
  ...BorderClassGroup,
  ...ColorClassGroup,
  ...ShadowClassGroup,
};
